// forumStats.js
import request from '@/utils/request';

export function getForumStats() {
  return request({
    url: '/v1/user_info/forum_stats',
    method: 'get',
  });
}
